import React, { useState, useRef, useEffect } from 'react';
import {
  useFloating,
  autoUpdate,
  offset,
  flip,
  shift,
} from '@floating-ui/react';

import { useModalStore } from '../../stores/useUIStore';

const PostActionsMenu = ({
  post,
  onUpdatePrivacy,
  onDeletePost,
  onQuotePost,
  onForwardPost,
  onEditPost,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = useModalStore((state) => state.openModal); // 🟢 OBTENEMOS LA FUNCIÓN PARA ABRIR MODALES

  // Lógica de Floating UI para posicionar el menú
  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-end',
    whileElementsMounted: autoUpdate,
    middleware: [offset(8), flip(), shift()],
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refs.floating.current &&
        !refs.floating.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handlePrivacyChange = (newPrivacy) => {
    onUpdatePrivacy(post._id, newPrivacy);
    setIsOpen(false);
  };

  const handleDelete = () => {
    if (
      window.confirm('¿Estás seguro de que quieres eliminar esta publicación?')
    ) {
      onDeletePost(post._id);
    }
    setIsOpen(false);
  };

  const handleQuotePost = () => {
    if (typeof onQuotePost === 'function') {
      onQuotePost(post);
    }
    setIsOpen(false);
  };

  // 🟢 SOLUCIÓN: Abrimos el modal y le pasamos los datos necesarios.
  const handleForwardPost = () => {
    openModal('forwardPost', { post: post, forwardPost: onForwardPost });
    setIsOpen(false);
  };

  const privacyOptions = [
    { value: 'public', label: 'Público', icon: 'fa-globe-americas' },
    { value: 'friends_only', label: 'Amigos', icon: 'fa-user-friends' },
    { value: 'private', label: 'Solo yo', icon: 'fa-lock' },
  ];

  return (
    <div className="relative">
      <button
        ref={refs.setReference}
        onClick={() => setIsOpen(!isOpen)}
        className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
      >
        <i className="fas fa-ellipsis-h"></i>
      </button>

      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          className="bg-white dark:bg-gray-800 rounded-md shadow-lg border border-gray-200 dark:border-gray-700 py-1 w-56 z-30"
        >
          <div className="px-3 py-2 text-xs text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
            Cambiar privacidad
          </div>
          {privacyOptions.map((opt) => (
            <button
              key={opt.value}
              onClick={() => handlePrivacyChange(opt.value)}
              className="w-full text-left flex items-center px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <i
                className={`fas ${opt.icon} w-6 mr-2 ${post.privacy === opt.value ? 'text-blue-600' : 'text-gray-400'}`}
              ></i>
              <span>{opt.label}</span>
              {post.privacy === opt.value && (
                <i className="fas fa-check ml-auto text-blue-600"></i>
              )}
            </button>
          ))}
          <div className="border-t border-gray-200 dark:border-gray-700 my-1"></div>
          <button
            onClick={() => onEditPost(post)}
            className="w-full text-left flex items-center px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <i className="fas fa-pencil-alt w-6 mr-2 text-gray-400"></i>
            <span>Editar</span>
          </button>
          <button
            onClick={handleQuotePost}
            className="w-full text-left flex items-center px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <i className="fas fa-quote-right w-6 mr-2 text-gray-400"></i>
            <span>Citar Publicación</span>
          </button>
          <button
            onClick={handleForwardPost}
            className="w-full text-left flex items-center px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <i className="fas fa-share w-6 mr-2 text-gray-400"></i>
            <span>Enviar a Amigos</span>
          </button>
          <button
            onClick={handleDelete}
            className="w-full text-left flex items-center px-3 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <i className="fas fa-trash-alt w-6 mr-2"></i>
            <span>Eliminar</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default PostActionsMenu;
